import React from "react";

const InsufficientRolePage: React.FC = () => {
  return <div>You haven't got a permissions to visit this site</div>;
};

export default InsufficientRolePage;
